<template>
    <div id="ranking">
        <table v-if="false" class="ranking-table w-full ">
            <thead>
                <tr>
                    <th>排名</th>
                    <th>省区域</th>
                    <th>综试区</th>
                    <th>指数得分</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in dataList">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.region }}</td>
                    <td>{{ item.areaName }}</td>
                    <td>{{ item.indexScore }}</td>
                </tr>
            </tbody>
        </table>




        <!-- <div class="list-container">
            <div class="marquee" id="carList">
                <template v-for="(item, index) in dataList">
                    <div class="list-item">
                        <div class="item-name text-overflow">{{ item }}</div>
                    </div>
                </template>
            </div>
        </div> -->
        <div class="ranking-table">

            <div class="flex justify-around t-header">
                <span style="width:40px" class="inline-block th">排名</span>
                <span style="width:120px" class="inline-block  th">省区域</span>
                <span style="width:220px" class="inline-block th">综试区</span>
                <span style="width:120px" class="inline-block th">指数得分</span>
            </div>
            <vue-seamless-scroll :data="dataList" :class-option="classOption" class="warp">
                <ul class="">
                    <li v-for="(item, index) in dataList" :key="index" class="flex justify-around tr">
                        {{ }}

                        <span style="width:40px" class="inline-block td" v-text="index + 1"></span>
                        <span style="width:120px" class="inline-block td" v-text="item.region"></span>
                        <span style="width:220px" class="inline-block td" v-text="item.areaName"></span>
                        <span style="width:120px" class="inline-block td" v-text="Number(item.indexScore).toFixed(2)"></span>
                    </li>
                </ul>
            </vue-seamless-scroll>
        </div>

    </div>
</template>

<script >
import { cmsSysCloudlsdDevelopIndex } from '../../../../api/home.js'
import vueSeamlessScroll from 'vue-seamless-scroll'


export default {
    name: "",
    components: {
        vueSeamlessScroll
    },
    props: {},
    data() {
        return {

            classOption: {
                step: 0.9
            },
            dataList: []
        };
    },
    watch: {},
    computed: {},
    methods: {
        async init() {
            //综试区发展指数-中下
            try {
                const res = await cmsSysCloudlsdDevelopIndex()
                this.dataList = res.data
            } catch (err) {
                this.$message.error("数据加载失败")
            }

        }
    },
    created() { },
    async mounted() {
        await this.init();
    }
}
</script>
<style lang="scss" scoped>
#ranking {
    .ranking-table {
        .t-header {
            background-color: #15233f;
        }

        .th {
            text-align: center;
            padding: 8px 0;
        }

        .tr:nth-child(odd) {
            background-color: #060D1C;
        }

        .tr:nth-child(even) {
            background-color: #0e192d;
        }


        .tr:nth-child(1) {
            @apply animate-pulse font-bold;
            color: red;

        }

        .tr:nth-child(2) {
            @apply animate-pulse font-bold;
            color: rgb(255, 168, 7);
        }

        .tr:nth-child(3) {
            @apply animate-pulse font-bold;
            color: rgb(255, 255, 0);
        }

        .td {
            text-align: center;
            padding: 8px 0;
        }

    }

    .warp {
        // height: 295px;
        margin: 0 auto;
        overflow: hidden;

        ul {
            list-style: none;
            padding: 0;
            margin: 0 auto;


            li,
            a {
                display: block;
                line-height: 30px;
                display: flex;
            }
        }
    }

}
</style>